<div class="full-height slate" role="alertdialog">
	<app-page-header id="announcements-header" [iconId]="261">Automated Notes Management</app-page-header>
	<app-spinner *ngIf="loading"></app-spinner>

	<!--<app-modal-template id="note-template" (saveClicked)="save()" (cancelClicked)="cancel()" iconId="261" title="Automated Notes Management" [working]="saving"-->
	<!--[disableSave]="!templateForm.valid" cancelText="Close" [cancelLeft]="true">-->
	<div *ngIf="!loading">
		<form [formGroup]="templateForm">
			<mat-form-field appearance="fill" style="width: 100%">
				<mat-label>{{ typeLabel }}</mat-label>
				<mat-select formControlName="encounterType">
					<mat-option *ngFor="let type of encounterTypes" [value]="type">
						{{ type.description }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field
				appearance="fill"
				style="width: 100%"
				*ngIf="useCategoryFilter && templateForm.get('encounterType').value"
			>
				<mat-label>{{ categoryLabel }}</mat-label>
				<mat-select formControlName="encounterCategoryType">
					<mat-option *ngFor="let type of filteredEncounterActionCategories" [value]="type">
						{{ type.description }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="fill" style="width: 100%" *ngIf="filteredEncounterActionTypes?.length > 0">
				<mat-label>{{ actionLabel }}</mat-label>
				<mat-select formControlName="encounterActionType">
					<mat-option *ngFor="let type of filteredEncounterActionTypes" [value]="type">
						{{ type.description }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<br />
			<mat-form-field appearance="fill" style="width: 100%" *ngIf="templateForm.get('encounterActionType').value">
				<mat-label>Template</mat-label>
				<textarea
					id="encounter-action-note-management-note-template-textarea"
					rows="4"
					matInput
					placeholder="Something {Keyword} something"
					formControlName="noteTemplate"
				></textarea>
			</mat-form-field>

			<div class="client-config-actions" *ngIf="templateForm.get('encounterActionType').value">
				<app-progress-button [working]="saving" (click)="save()"></app-progress-button>
			</div>
		</form>
	</div>

	<!--</app-modal-template>-->
	<!-- Action Buttons -->
</div>
